<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>General Information</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <cotecna-nf-form
      #naturalForm
      [config]="naturalFormConfig"
      [sections]="sections"
      [controls]="controls"
      (keypress)="ValidateKeyCode($event)"
    ></cotecna-nf-form>

    <div class="custom-fields-section">
      <ng-template #container></ng-template>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button (click)="addField()" mat-stroked-button color="accent">
      ADD ANOTHER FIELD
    </button>
  </mat-card-actions>
</mat-card>
